// Standard page sizes at 96 CSS px/in (matches what browsers paint and what we
// want printed). Keep these in sync with backend PDF margins (72 pt = 96 px).

export const PAGE_PADDING_X = 96;
export const PAGE_PADDING_Y = 96;
export const PAGE_GAP = 32;

export type PageSize = 'letter' | 'a4' | 'legal';

export interface PageDimensions {
  width: number;
  height: number;
  padX: number;
  padY: number;
  gap: number;
}

export const PAGE_SIZES: Record<PageSize, PageDimensions> = {
  letter: { width: 816,  height: 1056, padX: PAGE_PADDING_X, padY: PAGE_PADDING_Y, gap: PAGE_GAP },
  a4:     { width: 794,  height: 1123, padX: PAGE_PADDING_X, padY: PAGE_PADDING_Y, gap: PAGE_GAP },
  legal:  { width: 816,  height: 1344, padX: PAGE_PADDING_X, padY: PAGE_PADDING_Y, gap: PAGE_GAP },
};

export function getPageDims(size: PageSize = 'letter'): PageDimensions {
  return PAGE_SIZES[size];
}

// Back-compat exports — existing code imports these as scalars.
export const PAGE_WIDTH = PAGE_SIZES.letter.width;
export const PAGE_HEIGHT = PAGE_SIZES.letter.height;
